module.exports = __webpack_public_path__ + "img/8.d9765b36.png";